import React, { useState } from "react";
import { useNavigate } from "react-router";
import { useBookSection } from "../../../hooks/index";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "./BookSection.css";
import LightBox from "../../LightBox";

const BookSection = () => {
  const navigate = useNavigate();
  const { data, isLoading, isError, status } = useBookSection();
  const [open, setOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [lightBoxImages, setLightBoxImages] = useState([]);

  if (isLoading) return <div className="spinner"></div>;
  if (status === "failed") return <div>Error: {isError}</div>;
  if (!data || !data.books) return <></>;

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleClick = (id) => {
    navigate(`/sada-atal/${id}`);
    scrollToTop();
  };

  return (
    <div className="container border-bottom rounded-5 py-lg-4 py-4">
      <Swiper
        spaceBetween={30}
        slidesPerView={1}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        modules={[Autoplay]}
      >
        {data?.books?.map((book, index) => (
          <SwiperSlide key={book?._id}>
            <div className="row align-items-center">
              <div className="col-md-5">
                <div className="atal-bookimg-div border shadow rounded-5">
                  <img
                    onClick={() => {
                      setPhotoIndex(0);
                      setLightBoxImages(book?.cover_image);
                      setOpen(true);
                    }}
                    loading="lazy"
                    src={`${process.env.REACT_APP_BASE_IMG_URL}${book?.cover_image}`}
                    alt={book?.book_title}
                    className="img-fluid w-100 h-100 object-fit-cover rounded-5"
                  />
                </div>
              </div>
              <div className="col-md-7">
                <div className="py-3 px-4">
                  <p className="heading-font fs-3">{book?.book_title}</p>
                  <div
                    className="fw-light my-lg-4 fs-6 lh-lg"
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 7,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "normal",
                    }}
                    dangerouslySetInnerHTML={{ __html: book?.description }}
                  />
                  <button
                    onClick={() => handleClick(book?._id)}
                    className="custom-button"
                  >
                    More Details
                  </button>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <LightBox
        open={open}
        onClose={() => setOpen(false)}
        photoIndex={photoIndex}
        images={Array(lightBoxImages)}
        source={process.env.REACT_APP_BASE_IMG_URL}
      />
    </div>
  );
};

export default BookSection;
